import * as React from 'react';
import { Copy, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { copyToClipboard } from '@/lib/format';

interface CopyButtonProps {
  text: string;
  label?: string;
  className?: string;
  size?: 'default' | 'sm' | 'lg' | 'icon';
  'data-testid'?: string;
}

export function CopyButton({
  text,
  label,
  className,
  size = 'icon',
  'data-testid': testId,
}: CopyButtonProps) {
  const { t } = useTranslation();
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async () => {
    await copyToClipboard(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Button
      variant="ghost"
      size={size}
      onClick={handleCopy}
      aria-label={label || t('common.copyValue', { text })}
      data-testid={testId}
      className={className}
    >
      {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
    </Button>
  );
}
